import type { StateCreator } from 'zustand';
import type { Lead } from '../types';
import type { DialKontext } from '../services/leadGenApi';

// ADR 0371 (Stufe 2b): das zuletzt gespeicherte Anruf-Ergebnis, damit ein Streifen „Rückgängig“ (AppShell) es für
// ein paar Sekunden zurücknehmen kann, nachdem sich das Cockpit geschlossen hat, und das Abschluss-Fenster
// danach für dasselbe Gespräch wieder aufgeht (`korrektur`). Das Cockpit schreibt, der Streifen liest.
export interface LetzterAbschluss {
  callId: number;
  lead: Lead;
  wahl: DialKontext | null;
  ergebnis: string;                       // „NICHT ERREICHT“, nur zum Anzeigen
  kommentar: string;
  /** Hatte das Speichern einen Defekt-Vermerk an Nummern gesetzt: wird beim Zurücknehmen wieder aufgehoben. */
  defekt: { leadId: number; personKey: string | null; central: boolean; phoneKeys: string[] } | null;
  bis: number;                            // Date.now() + Frist des Streifens
}

export interface Korrektur { callId: number; kommentar: string }

export interface AbschlussRueckSlice {
  letzterAbschluss: LetzterAbschluss | null;
  korrektur: Korrektur | null;
  merkeAbschluss: (a: LetzterAbschluss) => void;
  vergissAbschluss: () => void;
  setzeKorrektur: (k: Korrektur | null) => void;
}

export const createAbschlussRueckSlice: StateCreator<AbschlussRueckSlice> = (set) => ({
  letzterAbschluss: null,
  korrektur: null,
  merkeAbschluss: (a) => set({ letzterAbschluss: a }),
  vergissAbschluss: () => set({ letzterAbschluss: null }),
  setzeKorrektur: (k) => set({ korrektur: k }),
});
